import { render, staticRenderFns } from "./Flota.vue?vue&type=template&id=549dac1c"
import script from "./Flota.vue?vue&type=script&lang=js"
export * from "./Flota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports